import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface UserExpirySaveRecord {
  client_key: string | number;
  user_sso: string | number;
  expiry_date: string;
}

/** Normalize gizmoGrid form callback payload (batch array or single row). */
export function normalizeUserExpiryRecords(payload: any): any[] {
  if (!payload) {
    return [];
  }
  if (Array.isArray(payload)) {
    return payload.map((e) => e?.data ?? e).filter(Boolean);
  }
  if (payload.rowData) {
    return [payload.rowData];
  }
  return [];
}

@Injectable()
export class AccessRenewalService {
  private readonly saveUrl = `${environment.base_url}/saveJsonObject?action_code=pvccel`;

  constructor(private http: HttpClient) {}

  saveUserExpiryReport(records: UserExpirySaveRecord[]): Observable<any> {
    const fd = new FormData();
    fd.append('clob_data', JSON.stringify(records));
    return this.http.post<any>(this.saveUrl, fd);
  }
}
